"use strict";

exports.__esModule = true;
exports.getDefaultQuestionResponse = exports.default = void 0;

var _constants = require("../../utils/constants");

var defaultProperties = {
  id: '',
  position: 1,
  title: '',
  description: '',
  conditions: []
};
var defaultValues = [Object.assign({}, defaultProperties, {
  component: {
    type: _constants.CHOICE_TYPE,
    props: {
      choices: [],
      multipleAnswers: false,
      required: true
    }
  }
}), Object.assign({}, defaultProperties, {
  component: {
    type: _constants.TEXT_ANSWER_TYPE,
    props: {
      longerResponse: false,
      required: true
    }
  }
}), Object.assign({}, defaultProperties, {
  component: {
    type: _constants.FILE_UPLOAD_TYPE,
    props: {
      acceptMultiple: false,
      required: true
    }
  }
}), Object.assign({}, defaultProperties, {
  component: {
    type: _constants.RATING_TYPE,
    props: {
      ratingOptions: 3,
      required: true
    }
  }
}), Object.assign({}, defaultProperties, {
  component: {
    type: _constants.ADDRESS_CHECKER_TYPE,
    props: {
      required: true
    }
  }
})];

var getDefaultQuestionResponse = function getDefaultQuestionResponse(type) {
  switch (type) {
    case _constants.CHOICE_TYPE:
    case _constants.FILE_UPLOAD_TYPE:
      return [];

    case _constants.RATING_TYPE:
    case _constants.TEXT_ANSWER_TYPE:
      return '';

    default:
      return null;
  }
};

exports.getDefaultQuestionResponse = getDefaultQuestionResponse;
var _default = defaultValues;
exports.default = _default;